/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Action_SearchInputs */

const cs_gdpr_action_search = /** @type {(inputs: Gdpr_Action_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledání`)
};

const en_gdpr_action_search = /** @type {(inputs: Gdpr_Action_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Searched`)
};

/**
* | output |
* | --- |
* | "Searched" |
*
* @param {Gdpr_Action_SearchInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_action_search = /** @type {((inputs?: Gdpr_Action_SearchInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Action_SearchInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_action_search(inputs)
	return cs_gdpr_action_search(inputs)
});